function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1ca6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1ca6"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $9f88767895e2bf6e$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"75mWo":"index.1fbf0323.js","2HCjO":"Kyle Clapper Resume.f1edc59f.pdf","8Canv":"hazmat.c0fc3b2f.jpeg","k63l2":"mics.0a1b7c97.jpg","fGEor":"counter-screenshot.2bb44d5b.png","2c5CB":"badstats-screenshot.a5338a9a.png","ivVcD":"index.59f6ff97.css","eC0j3":"index.9153c344.js","dvy72":"index.d28958fb.js"}'));


var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $9ATkq = parcelRequire("9ATkq");


var $gjLpa = parcelRequire("gjLpa");

var $ih19M = parcelRequire("ih19M");
function $1af7a593889101a8$export$2e2bcd8739ae039({ bg: bg = "none", text: text = "black", children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("p", {
        className: "rounded p-4 mt-3 bg-" + bg + " text-" + text,
        children: children
    });
}



var $ih19M = parcelRequire("ih19M");
function $66561da441faf702$export$2e2bcd8739ae039({ title: title, location: location, startDate: startDate, endDate: endDate, image: image, children: //imagePos='right',
children }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "pb-4",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "d-flex flex-wrap justify-content-between px-lg-4 pb-2",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "d-flex flex-column",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("h6", {
                                className: "display-6",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("small", {
                                children: location
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "mt-auto",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("small", {
                                children: [
                                    startDate,
                                    " "
                                ]
                            }),
                            endDate ? "-" : "",
                            /*#__PURE__*/ (0, $ih19M.jsxs)("small", {
                                children: [
                                    " ",
                                    endDate
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "clearfix border rounded p-lg-2",
                children: [
                    image ? /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                        src: image,
                        className: "col-12 col-lg-6 float-lg-end mb-3 ms-lg-3 rounded"
                    }) : null,
                    children
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
function $b30d1588edd5db34$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("h5", {
                className: "display-5 text-center",
                children: children
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("hr", {})
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
function $219c32d1a27c899c$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "container-lg px-4 px-lg-0 pt-4",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: "row justify-content-center",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "col-lg-8",
                children: children
            })
        })
    });
}


var $146f01d1a0ff7e9b$exports = {};

$146f01d1a0ff7e9b$exports = new URL((parcelRequire("kyEFX")).resolve("2HCjO"), import.meta.url).toString();


const $6294ebf60d7520b7$var$resume = new URL($146f01d1a0ff7e9b$exports);
var $4ed836014a597186$exports = {};

$4ed836014a597186$exports = new URL((parcelRequire("kyEFX")).resolve("8Canv"), import.meta.url).toString();


const $6294ebf60d7520b7$var$hazmat = new URL($4ed836014a597186$exports);
var $b2d264e6ca936d6e$exports = {};

$b2d264e6ca936d6e$exports = new URL((parcelRequire("kyEFX")).resolve("k63l2"), import.meta.url).toString();


const $6294ebf60d7520b7$var$mics = new URL($b2d264e6ca936d6e$exports);
var $ee8964fdb7e0bbba$exports = {};

$ee8964fdb7e0bbba$exports = new URL((parcelRequire("kyEFX")).resolve("fGEor"), import.meta.url).toString();


const $6294ebf60d7520b7$var$counter = new URL($ee8964fdb7e0bbba$exports);
var $d9126c386bac6328$exports = {};

$d9126c386bac6328$exports = new URL((parcelRequire("kyEFX")).resolve("2c5CB"), import.meta.url).toString();


const $6294ebf60d7520b7$var$badstats = new URL($d9126c386bac6328$exports);
function $6294ebf60d7520b7$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bh6RR.StrictMode), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $gjLpa.default), {}),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $219c32d1a27c899c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $1af7a593889101a8$export$2e2bcd8739ae039), {
                        bg: "secondary",
                        text: "light",
                        children: [
                            "For my CS210 students, I've posted the slides I use during discussion ",
                            /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                href: "/cs210",
                                children: "here."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("p", {
                        children: [
                            "My resume site has moved to ",
                            /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                href: "https://kyleclapper.dev",
                                children: "kyleclapper.dev"
                            }),
                            "head there to find my resume, cover letter, and blog."
                        ]
                    })
                ]
            })
        ]
    });
}
(0, $9ATkq.createRoot)(document.getElementById("app")).render(/*#__PURE__*/ (0, $ih19M.jsx)($6294ebf60d7520b7$export$2e2bcd8739ae039, {}));


//# sourceMappingURL=index.1fbf0323.js.map
